function EllipsisSvg () {
  return (
    <svg width="16" height="4" viewBox="0 0 16 4" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.16667 0C1.25 0 0.5 0.75 0.5 1.66667C0.5 2.58333 1.25 3.33333 2.16667 3.33333C3.08333 3.33333 3.83333 2.58333 3.83333 1.66667C3.83333 0.75 3.08333 0 2.16667 0ZM13.8333 0C12.9167 0 12.1667 0.75 12.1667 1.66667C12.1667 2.58333 12.9167 3.33333 13.8333 3.33333C14.75 3.33333 15.5 2.58333 15.5 1.66667C15.5 0.75 14.75 0 13.8333 0ZM8 0C7.08333 0 6.33333 0.75 6.33333 1.66667C6.33333 2.58333 7.08333 3.33333 8 3.33333C8.91667 3.33333 9.66667 2.58333 9.66667 1.66667C9.66667 0.75 8.91667 0 8 0Z" fill="#252525"/>
</svg>

  )
};

export default EllipsisSvg;